import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { FORM_NAME } from '../Form';

const selectEstimateId = state => formValueSelector(FORM_NAME)(state, 'estimate_id');

export default createSelector(
  selectEstimateId,
  (estimateId) => estimateId 
)